import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  constructor(
    private $http: HttpClient
  ) {
  }
  get isOneTimeToken(): boolean {
    const remember = localStorage.getItem(environment.tokenRememberKey);
    return ![true, 'true'].some(value => remember === value);
  }
  get value() {
    if (this.isOneTimeToken && document.cookie.indexOf('checkClose') === -1) {
      document.cookie = `checkClose=true;`;
      this.reset();
      return null;
    }
    return localStorage.getItem(environment.tokenKey);
  }
  set value(token: string) {
    localStorage.setItem(environment.tokenKey, token);
  }
  get hasValue(): boolean {
    return !!this.value;
  }
  verify(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.value) {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${this.value}`
        });
        this.$http.head('/token', { headers })
          .subscribe(() => resolve(true), () => resolve(false));
      } else {
        resolve(false);
      }
    });
  }
  rememberToken(data) {
    localStorage.setItem(environment.tokenRememberKey, data);
  }
  forgetToken() {
    localStorage.removeItem(environment.tokenRememberKey);
  }
  remove() {
    localStorage.removeItem(environment.tokenKey);
  }
  getSavedUser() {
    return localStorage.getItem(environment.tokenRememberKey);
  }

  get testValue() {
    return localStorage.getItem(environment.tokenKey)
  }
  removeAll() {
    localStorage.clear();
  }
  reset() {
    this.remove();
    this.forgetToken();
    // this.removeAll();
  }
  get header() {
    return `Bearer ${this.value}`;
  }
}
